import * as React from "react"

export default function useDisclosure() {
  const [isOpen, setIsOpen] = React.useState(false)
  const [isSecondaryOpen, setSecondaryIsOpen] = React.useState(false)

  const onOpen = React.useCallback(() => setIsOpen(true), [])
  const onClose = React.useCallback(() => setIsOpen(false), [])
  const onToggle = React.useCallback(() => setIsOpen(state => !state), [])

  const onSecondaryOpen = React.useCallback(() => setSecondaryIsOpen(true), [])
  const onSecondaryClose = React.useCallback(
    () => setSecondaryIsOpen(false),
    []
  )
  const onSecondaryToggle = React.useCallback(
    () => setSecondaryIsOpen(state => !state),
    []
  )

  return {
    isOpen,
    isSecondaryOpen,
    onOpen,
    onClose,
    onToggle,
    onSecondaryOpen,
    onSecondaryClose,
    onSecondaryToggle,
  }
}
